import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { TestcaseService } from '../../share/service/testcase.service';

@Component({
  selector: 'app-testcase',
  templateUrl: './testcase.component.html',
  styleUrls: ['./testcase.component.scss'],
})
export class TestcaseComponent implements OnInit {
  private subscription!: Subscription;
  private subscriptionStart: boolean = false;

  public testData = [
    {
      id: 1,
      name: 'Select your test case',
      value: '',
    },
    {
      id: 2,
      name: 'TEST_2_APPLICANT',
      value: 'TEST_2_APPLICANT',
    },
    {
      id: 3,
      name: 'TEST_1_APPLICANT',
      value: 'TEST_1_APPLICANT',
    },
    {
      id: 4,
      name: 'TEST_CASE_1',
      value: 'TEST_CASE_1',
    },
    {
      id: 5,
      name: 'TEST_CASE_2',
      value: 'TEST_CASE_2',
    },
    {
      id: 6,
      name: 'TEST_CASE_3',
      value: 'TEST_CASE_3',
    },
    {
      id: 7,
      name: 'TEST_CASE_4',
      value: 'TEST_CASE_4',
    },
    {
      id: 8,
      name: 'TEST_CASE_5',
      value: 'TEST_CASE_5',
    },
    {
      id: 9,
      name: 'TEST_CASE_6',
      value: 'TEST_CASE_6',
    },
    {
      id: 10,
      name: 'TEST_CASE_7',
      value: 'TEST_CASE_7',
    },
    {
      id: 11,
      name: 'TEST_CASE_8',
      value: 'TEST_CASE_8',
    },
    {
      id: 12,
      name: 'TEST_CASE_9',
      value: 'TEST_CASE_9',
    },
    {
      id: 14,
      name: 'TEST_CASE_10',
      value: 'TEST_CASE_10',
    },
  ];

  constructor(private testcaseService: TestcaseService) {}

  ngOnInit(): void {}

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    if (this.subscriptionStart) {
      this.subscription.unsubscribe();
    }
  }

  sendTestcase(e: any, version: string): void {
    let value = e.target.value;

    switch (version) {
      case 'old':
        this.getTocken(value);
        break;
      case 'new':
        this.getTockenNewApptrack(value);
    }
  }

  getTocken(value: string): void {
    this.subscription = this.testcaseService
      .getTocken(value)
      .subscribe((tocken: string) => {
        this.subscriptionStart = true;
        window.location.href =
          '/start/kredit-resultpage/?t=' + encodeURIComponent(tocken);

      });
  }

  getTockenNewApptrack(value: string): void {
    this.subscription = this.testcaseService
      .getTockenNewApptrack(value)
      .subscribe((tocken: string) => {
        this.subscriptionStart = true;
        window.location.href =
          '/start/kredit-resultpage/?t=' + encodeURIComponent(tocken);

      });
  }
}
